import Link from "next/link";
import Product from "@/public/images/product.png";
import Rating from "@/public/icon/rating.svg";
import Delete from "@/public/icon/delete.svg";
import QuantitySelector from "@/components/Quantity/Quantity";
import Image from "next/image";
import { useCheckout } from "@/hooks/useCheckout";

const CartCard = ({ item, onDelete, t }) => {
  const { removeFromCart, updateCartItem } = useCheckout();

  const handleDelete = () => {
    removeFromCart({
      product_id: item.product.id,
      volume_id: item.volume.id,
      succesMessage: t["success.message"],
      errorMessage: t["error.title"],
    });
    onDelete?.(item.product.id, item.volume.id);
  };

  const handleQuantityChange = (newCount) => {
    updateCartItem({
      product_id: item.product.id,
      volume_id: item.volume.id,
      count: newCount,
      succesMessage: t["success.message"],
      errorMessage: t["error.title"],
    });
  };

  return (
    <div className="orderRightCard">
      <Delete className="delete" onClick={handleDelete} />
      <Link
        href={`/products/${item?.product?.alias}?id=${item.product.id}`}
        className="img"
      >
        <Image
          src={item?.product?.title_image}
          alt="img"
          width={300}
          height={300}
        />
      </Link>
      <div className="orderRightCardDetail">
        <h6>{item?.product?.title}</h6>
        <div className="rating">
          <Rating />({item?.product?.rating})
        </div>
        <div className="mlClass">
          <QuantitySelector
            count={item.count}
            onChange={handleQuantityChange}
          />
          <div className="mlClassDetail">
            <span>{item?.volume?.volume}</span>
            {item.sale_price == 0 || item.sale_price == null ? (
              <strong>{item.price} ₼ </strong>
            ) : (
              <>
                {item.price != item.sale_price ? (
                  <div className="price">{item.sale_price} ₼</div>
                ) : (
                  <strong>{item.price} ₼</strong>
                )}
                {item.price != item.sale_price ? (
                  <div className="discount">{item.price} ₼</div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartCard;
